import { BreadcrumbData, AppBreadcrumbs, InitialBreadcrumb } from "@duosoftbg/nacid-components";
import { ProcessEnvironments } from "@duosoftbg/nacid-frontoffice-components";

export const breadcrumbData: BreadcrumbData = [
  { path: "/", name: "t.services", isHomePage: true },
  { path: "/official-notes-project", name: "t.page.officialNotes.short" },
  { path: "/official-notes-project/new", name: "t.new.application" },
  { path: "/official-notes-paper", name: "t.page.officialNotes.short" },
  { path: "/official-notes-paper/new", name: "t.new.application" },
  { path: "/official-notes-dissertation", name: "t.page.officialNotes.short" },
  { path: "/official-notes-dissertation/new", name: "t.new.application" },
  { path: "/official-notes-position", name: "t.page.officialNotes.short" },
  { path: "/official-notes-position/new", name: "t.new.application" },
  { path: "/inquiry-citings", name: "t.page.inquiry.short" },
  { path: "/inquiry-citings/new", name: "t.new.application" },
  { path: "/inquiry-factor", name: "t.page.inquiry.short" },
  { path: "/inquiry-factor/new", name: "t.new.application" },
  { path: "/bibliographic-reference-foreign", name: "t.page.biblioReference.short" },
  { path: "/bibliographic-reference-foreign/new", name: "t.new.application" },
  { path: "/bibliographic-reference-nacid", name: "t.page.biblioReference.short" },
  { path: "/bibliographic-reference-nacid/new", name: "t.new.application" },
  { path: "/document-delivery-libraries", name: "t.page.docDelivery.short" },
  { path: "/document-delivery-libraries/new", name: "t.new.application" },
  { path: "/document-delivery-nacid", name: "t.page.docDelivery.short" },
  { path: "/document-delivery-nacid/new", name: "t.new.application" },
  { path: "/he-recognition", name: "t.page.higherEduRecognition.short" },
  { path: "/se-recognition", name: "t.page.secondaryEduRecognition.short" },
  { path: "/se-verification-letter", name: "t.page.secondaryEduVerificationLetter.short" },
  { path: "/se-official-note", name: "t.page.secondaryEduOfficialNote.short" },
  { path: "/rudi-additional-doc", name: "t.page.rudiAdditionalDoc.short" },
  { path: "/rudi-additional-doc/new", name: "t.page.rudiAdditionalDoc.new.breadCrumb" },
  { path: "/regprof-additional-doc", name: "t.page.regprofAdditionalDoc.short" },
  { path: "/regprof-additional-doc/new", name: "t.page.regprofAdditionalDoc.new.breadCrumb" },
  { path: "/libserv-additional-doc", name: "t.page.libservAdditionalDoc.short" },
  { path: "/libserv-additional-doc/new", name: "t.page.libservAdditionalDoc.new.breadCrumb" },
  { path: "/my-applications/libserv-additional-documents/edit", name: "t.edit.application" },
  { path: "/my-applications/libserv-additional-documents/view", name: "t.view.application" },
  { path: "/my-applications/secondary-education-additional-documents/edit", name: "t.edit.application" },
  { path: "/my-applications/secondary-education-additional-documents/view", name: "t.view.application" },
  { path: "/my-applications/regprof-additional-documents/edit", name: "t.edit.application" },
  { path: "/my-applications/regprof-additional-documents/view", name: "t.view.application" },
  { path: "/my-applications/rudi-additional-documents/edit", name: "t.edit.application" },
  { path: "/my-applications/rudi-additional-documents/view", name: "t.view.application" },
  { path: "/se-additional-doc", name: "t.page.seAdditionalDoc.short" },
  { path: "/se-additional-doc/new", name: "t.page.seAdditionalDoc.new.breadCrumb" },
  { path: "/he-recognition/new", name: "t.new.application" },
  { path: "/se-recognition/new", name: "t.page.secondaryEduRecognition.new.breadCrumb" },
  { path: "/se-verification-letter/new", name: "t.page.secondaryEduVerificationLetter.new.breadCrumb" },
  { path: "/se-official-note/new", name: "t.page.secondaryEduOfficialNote.new.breadCrumb" },
  { path: "/doc-degrees-doctor", name: "t.page.doctorateDegrees.short" },
  { path: "/doc-degrees-doctor/new", name: "t.new.application" },
  { path: "/doc-degrees-doctor-science", name: "t.page.doctorateDegrees.short" },
  { path: "/doc-degrees-doctor-science/new", name: "t.new.application" },
  { path: "/regprof", name: "t.page.regprof.short" },
  { path: "/regprof/new", name: "t.new.application" },
  { path: "/uni-checks-status", name: "t.page.uniChecks.short" },
  { path: "/uni-checks-status/new", name: "t.new.application" },
  { path: "/uni-checks-authenticity", name: "t.page.uniChecks.short" },
  { path: "/uni-checks-authenticity/new", name: "t.new.application" },
  { path: "/uni-checks-recommendation", name: "t.page.uniChecks.short" },
  { path: "/uni-checks-recommendation/new", name: "t.new.application" },
  { path: "/suggestion", name: "t.page.suggestion.short" },
  { path: "/suggestion/new", name: "t.new.application" },
  { path: "/signal", name: "t.page.signal.short" },
  { path: "/signal/new", name: "t.new.application" },
  { path: "/public-access", name: "t.page.publicAccess.short" },
  { path: "/public-access/new", name: "t.new.application" },
  {
    path: "/my-applications",
    name: "t.page.my.applications",
    parentOverride: [
      { path: `${ProcessEnvironments.Module.FrontOffice.Portal}/personal-content`, name: "t.header.personalContent" },
    ],
  },
  { path: "/my-applications/se-application/edit", name: "t.edit.application" },
  { path: "/my-applications/se-application/view", name: "t.view.application" },
  { path: "/my-applications/he-recognition/edit", name: "t.edit.application" },
  { path: "/my-applications/he-recognition/view", name: "t.view.application" },
  { path: "/my-applications/uni-checks/edit", name: "t.edit.application" },
  { path: "/my-applications/uni-checks/view", name: "t.view.application" },
  { path: "/my-applications/regprof/edit", name: "t.edit.application" },
  { path: "/my-applications/regprof/view", name: "t.view.application" },
  { path: "/my-applications/doc-degrees/edit", name: "t.edit.application" },
  { path: "/my-applications/doc-degrees/view", name: "t.view.application" },
  { path: "/my-applications/official-notes/edit", name: "t.edit.application" },
  { path: "/my-applications/official-notes/view", name: "t.view.application" },
  { path: "/my-applications/inquiry/edit", name: "t.edit.application" },
  { path: "/my-applications/inquiry/view", name: "t.view.application" },
  { path: "/my-applications/bibliographic-reference/edit", name: "t.edit.application" },
  { path: "/my-applications/bibliographic-reference/view", name: "t.view.application" },
  { path: "/my-applications/document-delivery/edit", name: "t.edit.application" },
  { path: "/my-applications/document-delivery/view", name: "t.view.application" },
  { path: "/my-applications/signal/edit", name: "t.edit.application" },
  { path: "/my-applications/signal/view", name: "t.view.application" },
  { path: "/my-applications/suggestion/edit", name: "t.edit.application" },
  { path: "/my-applications/suggestion/view", name: "t.view.application" },
  { path: "/my-applications/public-access/edit", name: "t.edit.application" },
  { path: "/my-applications/public-access/view", name: "t.view.application" },
  { path: "/my-applications/signed-document-details", name: "t.page.signed.document.details" },
  { path: "/app-checkup", name: "t.page.appCheckup" },
  { path: "/app-checkup/he-recognition", name: "t.page.higherEduRecognition.short" },
  { path: "/app-checkup/uni-checks", name: "t.page.uniChecks.short" },
  { path: "/app-checkup/doc-degrees", name: "t.page.doctorateDegrees.short" },
  { path: "/app-checkup/regprof", name: "t.page.regprof.short" },
  { path: "/app-checkup/official-notes", name: "t.page.officialNotes.short" },
  { path: "/app-checkup/inquiry", name: "t.page.inquiry.short" },
  { path: "/app-checkup/bibliographic-reference", name: "t.page.biblioReference.short" },
  { path: "/app-checkup/document-delivery", name: "t.page.docDelivery.short" },
  { path: "/app-checkup/signal", name: "t.page.signal.short" },
  { path: "/app-checkup/suggestion", name: "t.page.suggestion.short" },
  { path: "/app-checkup/public-access", name: "t.page.publicAccess.short" },
  {
    path: "/my-correspondence",
    name: "t.page.my.correspondence",
    parentOverride: [
      { path: `${ProcessEnvironments.Module.FrontOffice.Portal}/personal-content`, name: "t.header.personalContent" },
    ],
  },
];

export const initialBreadcrumb: InitialBreadcrumb = [
  { path: `${ProcessEnvironments.Module.FrontOffice.Portal}`, name: "l.start", external: true },
];

const Breadcrumbs = () => {
  return <AppBreadcrumbs data={breadcrumbData} initial={initialBreadcrumb} />;
};

export default Breadcrumbs;
